import { ReactNode } from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { getFormIconColor } from 'src/components/utils/stylingFunctions';
import { FormState } from 'src/types';
import { useTheme } from 'styled-components';
import {
  CloseIcon,
  InformationBannerDescription,
  InformationBannerDetails,
  InformationBannerStyled,
  InformationBannerTitle,
} from './InformationBanner.styles';

interface Props {
  state:
    | FormState.ERROR
    | FormState.WARNING
    | FormState.SUCCESS
    | FormState.DEFAULT
    | FormState.INFO;
  title?: string;
  icon?: string;
  description?: string | ReactNode;
  $descriptionLineDrop?: boolean;
  $fullWidth?: boolean;
  $centerIconVertically?: boolean;
  onCloseMessage?: () => void;
  'data-testid'?: string;
}

export const InformationBanner = ({
  state,
  title,
  description,
  onCloseMessage,
  ...props
}: Props) => {
  const theme = useTheme();
  return (
    <InformationBannerStyled {...props} state={state}>
      <StyledIcon
        className={
          props.icon ??
          (state === FormState.DEFAULT
            ? 'uil uil-comment-info'
            : 'uil uil-exclamation-triangle')
        }
        size="24px"
        color={getFormIconColor(state, theme)}
      />
      <InformationBannerDetails>
        {title && (
          <InformationBannerTitle state={state}>{title}</InformationBannerTitle>
        )}
        {description && (
          <InformationBannerDescription state={state}>
            {description}
          </InformationBannerDescription>
        )}
      </InformationBannerDetails>
      {onCloseMessage && (
        <CloseIcon
          size="16px"
          className="uil uil-multiply"
          onClick={onCloseMessage}
          color={theme.atlas.semantic.color.type.default}
        />
      )}
    </InformationBannerStyled>
  );
};
